var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[(_vm.news.header)?_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.news.header))])]):_vm._e(),_c('ol',_vm._l((_vm.news.news),function(item,index){return _c('li',{key:index},[_c('h3',[_vm._v(_vm._s(item.header))]),_c('span',[_vm._v(_vm._s(item.date))]),_c('p',[_vm._v(_vm._s(item.paragraph))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }